export default __webpack_public_path__ + "static/media/2141.0de9e75e.png";